import { computed, ComputedRef } from 'vue'

import { ReviewPostPageStateViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostPageStateViewModel'

export class ReviewPostPageStatePresenter {
  private viewModel: ReviewPostPageStateViewModel

  constructor(viewModel: ReviewPostPageStateViewModel) {
    this.viewModel = viewModel
  }

  get isFirstOpendPage(): ComputedRef<boolean> {
    return this.viewModel.isFirstOpendPage
  }

  get entrySummaryExpandedList(): ComputedRef<{ [entryId: string]: boolean }> {
    return this.viewModel.entrySummaryExpandedList
  }

  get entrySelectedReviewIndexList(): ComputedRef<{ [entryId: string]: number }> {
    return this.viewModel.entrySelectedReviewIndexList
  }

  get entryEditingList(): ComputedRef<{ [entryId: string]: boolean }> {
    return this.viewModel.entryEditingList
  }

  // エントリー[entryId]のサマリーが展開されているかどうかを返す
  isSummaryExpanded(entryId: string): ComputedRef<boolean> {
    return computed(() => this.viewModel.entrySummaryExpandedList.value[entryId])
  }

  isDetailSelected(entryId: string): ComputedRef<boolean> {
    return computed(
      () =>
        entryId in this.viewModel.entrySelectedReviewIndexList.value &&
        this.viewModel.entrySelectedReviewIndexList.value[entryId] !== -1
    )
  }

  setIsFirstOpendPage(flag: boolean): void {
    this.viewModel.setIsFirstOpendPage(flag)
  }

  setEntrySummaryExpandedFlag(entryId: string, flag: boolean): void {
    this.viewModel.setEntrySummaryExpandedFlag(entryId, flag)
  }

  setEntrySelectedReviewIndex(entryId: string, selectedReviewIndex: number): void {
    if (this.entrySelectedReviewIndexList.value[entryId] === selectedReviewIndex) {
      this.viewModel.setEntrySelectedReviewIndex(entryId, -1)
      return
    }
    this.viewModel.setEntrySelectedReviewIndex(entryId, selectedReviewIndex)
    this.viewModel.setEntryEditingFlag(entryId, false)
  }

  reverseEntryEditingFlag(entryId: string): void {
    this.viewModel.setEntryEditingFlag(entryId, !this.entryEditingList.value[entryId])
    this.viewModel.setEntrySelectedReviewIndex(entryId, -1)
  }
}
